import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BASE_URL } from "static/constants";
import {
  deleteApiJobs,
  fetchApiJobs,
  markApiJobComplete,
  retryApiJobs,
} from "app/services/job/apiJob";

export const jobApi = createApi({
  reducerPath: "jobApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["jobs"],
  endpoints: ({ query, mutation }) => ({
    getJobs: query({
      queryFn: (query) => {
        return { data: fetchApiJobs(query) };
      },
      providesTags: ["jobs"],
    }),
    markJobComplete: mutation({
      queryFn: (jobs) => {
        return { data: markApiJobComplete(jobs) };
      },
      invalidatesTags: ["jobs"],
    }),
    retryJobs: mutation({
      queryFn: (jobs) => {
        return { data: retryApiJobs(jobs) };
      },
      invalidatesTags: ["jobs"],
    }),
    deleteJobs: mutation({
      queryFn: (jobs) => {
        return { data: deleteApiJobs(jobs) };
      },
      invalidatesTags: ["jobs"],
    }),
  }),
});

export const {
  useGetJobsQuery,
  useMarkJobCompleteMutation,
  useRetryJobsMutation,
  useDeleteJobsMutation,
} = jobApi;
